import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { PageHeader } from '../components/Layout';
import { Spinner } from '../components/UI';
import WorkFeed from '../components/WorkFeed';

export default function HomePage() {
  const { user, loading } = useAuth();
  if (loading) return <Spinner label="Opening Area" />;
  return <div className="page home-page">
    <PageHeader title={user ? 'Home' : 'Area'}>
      <Link className="secondary-button" to={user ? '/people' : '/login'}>{user ? 'Find people' : 'Join Area'}</Link>
    </PageHeader>
    <div className="page-body">
      {!user && <section className="artist-hero">
        <h2>Life happens<br /><em>around you.</em></h2>
        <div className="hero-actions"><Link className="pill-button" to="/login">Join the conversation <ArrowRight size={17} /></Link><Link className="text-link" to="/clubs">Explore community circles <ArrowRight size={15} /></Link></div>
      </section>}
      <section><WorkFeed /></section>
    </div>
  </div>;
}
